module.exports = "/_next/static/images/profile-kah-9badc0a394e934f0acdb9ea7ecf90dbf.png";